import { NumericDiff } from "components/search/input/DifferencePanel/common";
import { NameBasedTargetInventoryItem } from "store/api/generatedApi";

import { CategoryConfigFactory } from "components/search/input/DifferencePanel/common";

export const TargetInventoryItemConfigFactory: CategoryConfigFactory<
  NameBasedTargetInventoryItem
> = ({ t, units, formatNumber2DP }) => ({
  min_quantity: {
    title: t("targetMin"),
    format: (val) => `${formatNumber2DP(val)}${units("mass")}`,
    renderDiff: ({ updatedVal, previousVal }) => {
      return (
        <NumericDiff
          previous={previousVal ?? 0}
          updated={updatedVal ?? 0}
          suffix={units("mass")}
          format={formatNumber2DP}
        />
      );
    },
  },
  max_quantity: {
    title: t("targetMax"),
    format: (val) => `${formatNumber2DP(val)}${units("mass")}`,
    renderDiff: ({ updatedVal, previousVal }) => (
      <NumericDiff
        previous={previousVal ?? 0}
        updated={updatedVal ?? 0}
        suffix={units("mass")}
        format={formatNumber2DP}
      />
    ),
  },
});
